import React, { useState, useCallback, useEffect, useMemo } from 'react';
import moment from 'moment';
import Filter from '@/pages/intelligence/components/Filter';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import { getFilterExtendDefaultValue, } from '@intelligence/utils/filterUtils';
import { useUpdateFilterFormValues } from '@intelligence/hooks/useUpdateFilterFormValues';

export const defaultValue = {
  [filterKeyMap.RANGE_TIME]: {
    type: 'month',
    value: ['', ''],
  },
};

export default function PCUDetailFilter(props: any) {
  const {
    timeFilterValues,
    filterConfirm,
    sinceReleaseTime,
    earliestDataTime,
  } = props;

  // 继承逻辑在这写
  const { isOperateDetail, detailFilterExtend, setDetailFilterExtend } = useFilterExtend(
    {},
  );
  const extendDefaultFilterValue = getFilterExtendDefaultValue(isOperateDetail, detailFilterExtend, defaultValue);
  const [extendDefaultValue] = useState(!isOperateDetail
    ? defaultValue
    : {
      [filterKeyMap.RANGE_TIME]: extendDefaultFilterValue?.[filterKeyMap.RANGE_TIME],
    });

  const [formValue, setFormValue] = useState(extendDefaultValue);

  const updateInputList = () => [
    {
      type: filterKeyMap.RANGE_TIME,
      key: filterKeyMap.RANGE_TIME,
      calendarType: 'month',
      earliestDataTime,
      sinceReleaseTime,
      isShowAlloftime: false,
    }
  ];

  const [inputList, setInputList] = useState(updateInputList());

  useEffect(() => {
    /** 国家筛选器的列表值 */
    const newInputList = updateInputList();
    setInputList(newInputList);
  }, [earliestDataTime, sinceReleaseTime]);

  /** 时间筛选器值由父组件更新 */
  const combinedValues = useUpdateFilterFormValues({
    formValue,
    timeFilterValues,
  });

  useEffect(() => {
    setFormValue(combinedValues);
  }, [JSON.stringify(combinedValues)]);

  const onConfirm = useCallback(
    (value, apiValue) => {
      setFormValue(value);
      /** 修改筛选器值转换为接口参数 */
      const filterForm = {
        date_type: apiValue[filterKeyMap.RANGE_TIME]?.granularity,
        start_date: apiValue[filterKeyMap.RANGE_TIME]?.start_date,
        end_date: apiValue[filterKeyMap.RANGE_TIME]?.end_date,
      };
      filterConfirm(filterForm);
      setDetailFilterExtend(apiValue);
    },
    [filterConfirm],
  );

  return (
    <Filter
      value={formValue}
      inputList={inputList}
      // onInit={onInit}
      onConfirm={onConfirm}
      onReset={() => { }}
      showButton={false}
      defaultValue={defaultValue}
    />
  );
}
